/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import PropTypes from 'prop-types';
import MediaGalleryListItem from './MediaGalleryListItem';

const MediaGalleryList = props => (
  <ul className="list-unstyled media-gallery-list" id={(props.mediaType === 'video' ? 'media-type-tab-panel-videos-panel' : 'media-type-tab-panel-images-panel')} tabIndex="0">
    {props.items.map(item => <MediaGalleryListItem key={item} item={item} handleMediaClick={props.handleMediaClick} />)}
  </ul>
);

MediaGalleryList.propTypes = {
  handleMediaClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  mediaType: PropTypes.string,
};

export default MediaGalleryList;
/* eslint-enable jsx-a11y/no-noninteractive-tabindex */
